import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRCondition } from '../../../../models';

@Component({
  selector: 'app-conditions-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './conditions-section.component.html',
  styles: [
    `
      .section-banner {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        padding: 0.85rem 1.25rem;
        font-weight: 700;
        font-size: 1.05rem;
        border-radius: 6px 6px 0 0;
        background-color: #ffc107;
        color: #1a1a1a;
      }
      .section-banner i,
      .section-banner .banner-icon {
        font-size: 1.2rem;
      }
      .section-banner-body {
        padding: 1rem 1.25rem;
        border: 1px solid #dee2e6;
        border-top: none;
        border-radius: 0 0 6px 6px;
        background: #fff;
      }
    `,
  ],
})
export class ConditionsSectionComponent {
  readonly conditions = input.required<FHIRCondition[]>();

  getEstadoBadge(estado: string): { color: string; label: string } {
    const s = (estado || '').toLowerCase();
    if (s.includes('active') || s.includes('activ')) return { color: 'bg-danger', label: 'Activo' };
    if (s.includes('resolved') || s.includes('resuel'))
      return { color: 'bg-success', label: 'Resuelto' };
    if (s.includes('inactive') || s.includes('inactiv'))
      return { color: 'bg-secondary', label: 'Inactivo' };
    return { color: 'bg-info', label: estado || 'N/A' };
  }

  getVerifBadge(estado: string): { color: string; label: string } {
    const s = (estado || '').toLowerCase();
    if (s.includes('confirmed') || s.includes('confirm'))
      return { color: 'bg-success', label: 'Confirmado' };
    if (s.includes('provisional')) return { color: 'bg-warning text-dark', label: 'Provisional' };
    if (s.includes('refuted')) return { color: 'bg-danger', label: 'Refutado' };
    return { color: 'bg-secondary', label: estado || 'N/A' };
  }

  getDisplay(concept: any): string {
    return concept?.coding?.[0]?.display || concept?.coding?.[0]?.code || concept?.text || '—';
  }

  getCodigo(concept: any): string {
    return concept?.coding?.[0]?.code || '';
  }
}
